import Swiper from 'swiper';
import UiHelper from './UiHelper';

const selectors = {
    wrap: '.hero-slider',
    prev: '.js-hero-slider__prev',
    next: '.js-hero-slider__next'
}

class HeroSliderFactory
{
    static init()
    {
        Array.from(UiHelper.getNodes(selectors.wrap)).forEach(wrap =>
        {
            new HeroSlider(wrap);
        });
    }
}
export default HeroSliderFactory;

class HeroSlider
{
    constructor(wrap)
    {
        const effect = wrap.dataset.effect ? wrap.dataset.effect : 'fade';
        const duration = (wrap.dataset.duration ? wrap.dataset.duration : 5) * 1000;
        const autoplay = wrap.dataset.autoplay ? wrap.dataset.autoplay : false;

        let options = {};

        if (autoplay) {
            options = {
                speed: 500,
                loop: true,
                effect: effect,
                autoplay: {
                    delay: duration,
                },
                pagination: {
                    el: '.js-hero-pagination',
                    clickable: true,
                    // renderBullet: function (index, className) {
                    //     return '<span class="' + className + '">' + (index + 1) + '</span>';
                    // },
                }
            }
        } else {
            options = {
                speed: 500,
                loop: true,
                effect: effect,
                autoplay: false,
                pagination: {
                    el: '.swiper-pagination',
                }
            }
        }

        this.swiper = new Swiper(wrap, options);

        this.prev = wrap.querySelector(selectors.prev);
        this.next = wrap.querySelector(selectors.next);

        this.prev.addEventListener('click', e => { this.swiper.slidePrev(); });
        this.next.addEventListener('click', e => { this.swiper.slideNext(); });
    }
}